
import Dictionary from "./Dictionary"
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
    
        <Dictionary default="ego"/>
       
      </header>
    </div>
  );
}

export default App;
